import App from './App.component';

export default App;